<template>
  <div class="lead-content">
    <div class="end-page-spacing">
      <h1 class="mb-3 lead-title">HOW THE SWAMPUM POINT SYSTEM WORKS</h1>
      <div
        class="md-layout md-gutter md-alignment-center-center"
        id="guter-content"
      >
        <div class="md-layout-item md-size-15 item-content md-elevation-1">
          <div class="img-content">
            <img src="/img/Polygon_7.svg" alt="" />
          </div>
          <p>
            Earn bonus points by registering, posting items, and inviting your
            friends
          </p>
        </div>
        <div class="md-layout-item md-size-15 item-content md-elevation-1">
          <div class="img-content">
            <img src="/img/select.svg" alt="" />
          </div>
          <p>
            Lend and sell <br />
            stuff to earn <br />
            more Swampum <br />
            points
          </p>
        </div>
        <div class="md-layout-item md-size-15 item-content md-elevation-1">
          <div class="img-content">
            <img src="/img/smartphone.svg" alt="" />
          </div>
          <p>
            Use your points to<br />
            buy or borrow things from other<br />
            Swampum users
          </p>
        </div>
        <div
            data-toggle="tooltip"
            data-placement="bottom"
            :data-original-title="privacyTooltip"
            :data-html="true"
            class="md-layout-item md-size-15 item-content md-elevation-1 privacy-tooltip"
          >
            <div class="img-content">
              <img src="/img/transaction_1.svg" alt="" />
            </div>
            <p>
              You decide how many points each item is worth
            </p>
        </div>
      </div>
    </div>
    <SRegisterButton v-if="registerButton" />
  </div>
</template>

<script>
import SRegisterButton from "@/material-components/atoms/SRegisterButton.vue";

export default {
  name: "HowSwampumPointsWorks",
  props: ["registerButton"],
  components: {
    SRegisterButton,
  },
  data() {
    return {
      show: false,
      mouseEnter: false,
    };
  },
  computed: {
    privacyTooltip() {
      return "<p><em>But we suggest</em> using 100 points = 100 US cents as a guideline<p>";
      }
    },
    mounted() {
    $(".privacy-tooltip").tooltip();
  },
};
</script>

<style lang="scss" scoped>
  .md-section-center {
    justify-content: center;
  }
  .lead-content {
  background-color: $light;
  margin: auto;
}
.end-page-spacing {
  margin-bottom: 8rem;
}
.item-content {
  background-color: $white;
  border-radius: 16px;
  margin-left: 2rem;
  height: 15.9rem;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;
}
.item-content:first-child {
  margin-left: 0;
}
.item-content p {
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 1.3px;
  letter-spacing: 1px;
  margin-top: 2rem;
  margin-bottom: 0px;
  color: $black;
  height: 40%;
}
.item-content img {
  width: 100px;
  height: 86px;
  align-self: center;
  margin-top: 0.8rem;
}
</style>

<style lang="scss" scoped>
.lead-title {
  text-align: center;
  font-weight: bold;
  line-height: 36px;
  font-size: 36px;
  letter-spacing: 1.25px;
  padding: 2.5rem !important;
  color: $black;
}
.drop-information{
  padding-right: 1rem;
  padding-left: 1rem;
}
@media screen and (max-width: 1106px) {
  .md-gutter {
    flex-direction: column !important;
  }

  .item-content {
    min-width: 20rem !important;
    height: unset;
    margin-left: 0;
    margin-bottom: 2.5rem;
  }

  .item-content img {
    margin-top: 2.5rem;
  }
}
@media screen and (max-width: 1199px) {
  .item-content p {
    font-size: 12px;
  }
}
</style>
